import { render, staticRenderFns } from "./PiedPageULaval.vue?vue&type=template&id=3573943e&scoped=true&"
import script from "./PiedPageULaval.vue?vue&type=script&lang=ts&"
export * from "./PiedPageULaval.vue?vue&type=script&lang=ts&"
import style0 from "./PiedPageULaval.vue?vue&type=style&index=0&id=3573943e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573943e",
  null
  
)

export default component.exports